<template>
	<div>
		<div class="weui-cells" @click="toPerson" v-show="!isReceipt">
			<div class="weui-cell weui-cell_active weui-cell_access">
				<div class="weui-cell__bd">
					<span style="vertical-align: middle;">个人缴费</span>
				</div>
				<div class="weui-cell__ft"></div>
			</div>
		</div>

		<div class="weui-cells" @click="toMerchant" v-if="isBusinessManager > 0 && !isReceipt">
			<div class="weui-cell weui-cell_active weui-cell_access">
				<div class="weui-cell__bd">
					<span style="vertical-align: middle;">商户缴费</span>
				</div>
				<div class="weui-cell__ft"></div>
			</div>
		</div>

		<div class="weui-cells" @click="toParkingRecord(1)">
			<div class="weui-cell weui-cell_active weui-cell_access">
				<div class="weui-cell__bd">
					<span style="vertical-align: middle;">个人缴费{{isReceipt ? '开票' : '历史'}}</span>
				</div>
				<div class="weui-cell__ft"></div>
			</div>
		</div>

		<div class="weui-cells" @click="toParkingRecord(2)" v-if="isBusinessManager > 0">
			<div class="weui-cell weui-cell_active weui-cell_access">
				<div class="weui-cell__bd">
					<span style="vertical-align: middle;">商户缴费{{isReceipt ? '开票' : '历史'}}</span>
				</div>
				<div class="weui-cell__ft"></div>
			</div>
		</div>
	</div>
</template>

<script>
    import { getWxUserInfo } from "../../../../api/coupon/personalCenter";
    import { mapGetters, mapMutations } from 'vuex'
    export default {
        name: "index",
		data () {
            return {
                isReceipt: false,
                isBusinessManager: 0
			}
		},
		computed: {
			...mapGetters(['userOpenid'])
		},
		created () {
            this.isReceipt = this.$route.query.isReceipt;
            if ( localStorage.getItem('userOpenId')||this.userOpenid) 
			this.getUserInfo()
		},
		methods: {
            /*获取用户信息**/
            getUserInfo () {
				getWxUserInfo(localStorage.getItem('userOpenId')||this.userOpenid  ).then(res =>{
                    this.setBusinessIds(res.data.businessIds);
                    this.isBusinessManager = res.data.isBusinessManager
				})
            },
            toPerson () {
                this.$router.push({name:'toPayParkingFee'})
			},
            toMerchant () {
                this.$router.push({name:'merChantToPayParkingFee'})
			},
            toParkingRecord (where) {
                this.$router.push({name:'parkingFeeRecord'});
                if (where === 1){
                    this.setClickMerRecord(false)
				} else {
                    this.setClickMerRecord(true)
				}
			},
            ...mapMutations({
                setBusinessIds: "SET_BUSINESS_IDS",
				setClickMerRecord: "SET_CLICKMERRECORD"
            }),
		}
    }
</script>

<style scoped lang="stylus">
	.weui-cells{
		margin-top 0
		.weui-cell_access{
			display flex
			justify-content space-between
		}
	}
	.weui-cell_access .weui-cell__cash{
		padding-right 0
	}
	.weui-cell_access .weui-cell__cash:after{
		width 0
		height 0
		border-width 0
	}
	.weui-cell__ft::after{
		content:" ";
		display:inline-block;
		height:8px;
		width:8px;
		border-width:2px 2px 0 0;
		border-color:#B2B2B2;
		border-style:solid;
		-webkit-transform:matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		transform:matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
		position:absolute;
		top:50%;
		margin-top:-5px;
		right:0;
	}
</style>
